import React from 'react';
import {TRANSLATE_TIER3, TRANSLATE_SETTINGS, TRANSLATE_REPORTS, TRANSLATE_PRODUCTION_PLANNING, TRANSLATE_ME_MANAGER, 
    TRANSLATE_APPLICATION, TRANSLATE_USERS, TRANSLATE_CREATE_USER, TRANSLATE_ROLES, TRANSLATE_CREATE_ROLE} from '../../translates/Translates';
import { path_tier3, path_me_manager, path_production_planning, path_reports, path_users, 
    path_create_user, path_roles, path_create_role } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {setOpenedOrClosedSubmenu} from '../../client/helpers/LeftMenuHelper';

const SidebarNavigation = () => {
    return(
        <nav className="sidebar-nav active">
            <ul id="sidebarnav" className="in">
                <li className="nav-small-cap">{TRANSLATE_APPLICATION}</li>
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={path_tier3}>
                        <i className="far fa-list-alt"></i>
                        <span className="hide-menu">{TRANSLATE_TIER3}</span>
                    </Link>
                </li>
                <li className="nav-devider"></li>
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={path_me_manager}>
                        <i className="fas fa-project-diagram"></i>
                        <span className="hide-menu">{TRANSLATE_ME_MANAGER}</span>
                    </Link>
                </li>
                <li className="nav-devider"></li>
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={path_production_planning}>
                        <i className="fas fa-table"></i>
                        <span className="hide-menu">{TRANSLATE_PRODUCTION_PLANNING}</span>
                    </Link>
                </li>
                <li className="nav-devider"></li>
                <li>
                    <Link className="has-arrow waves-effect waves-dark" to={path_reports}>
                        <i className="fas fa-chart-bar"></i>
                        <span className="hide-menu">{TRANSLATE_REPORTS}</span>
                    </Link>
                </li>
                <li className="nav-devider"></li>
                <li id="item-with-submenu">
                    <button className="has-arrow waves-effect waves-dark" to="" onClick={setOpenedOrClosedSubmenu} aria-expanded="false">
                        <i className="fas fa-user-cog"></i>
                        <span className="hide-menu">{TRANSLATE_SETTINGS}</span>
                        <i className="nav-arrow-icon fas fa-chevron-down"></i>
                        <i className="nav-arrow-icon fas fa-chevron-up"></i>
                    </button>
                    <ul aria-expanded="false" className="collapse" id="sidebar-nav-submenu">
                        <li>
                            <Link className="has-arrow waves-effect waves-dark" to={path_users}>
                                <i className="fas fa-users"></i>
                                <span className="hide-menu">{TRANSLATE_USERS}</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="has-arrow waves-effect waves-dark" to={path_create_user}>
                                <i className="fas fa-user-plus"></i>
                                <span className="hide-menu">{TRANSLATE_CREATE_USER}</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="has-arrow waves-effect waves-dark" to={path_roles}>
                                <i className="fas fa-user-tag"></i>
                                <span className="hide-menu">{TRANSLATE_ROLES}</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="has-arrow waves-effect waves-dark" to={path_create_role}>
                                <i className="fas fa-plus-circle"></i>
                                <span className="hide-menu">{TRANSLATE_CREATE_ROLE}</span>
                            </Link>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    )
}

export default SidebarNavigation;
